import { NavLink } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';

import {
  CurateIcon,
  HomeIcon,
  LensIcon,
} from '@/components/ui/Icon';
import { ROUTES } from '@/routes/paths';

import styles from './BottomNav.module.css';

interface NavItem {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Match exact path only. False means prefix-match (used by routes with children). */
  exact?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: ROUTES.dashboard, label: 'Home', Icon: HomeIcon, exact: true },
  // Lens redirects to /lens/rsq, so use prefix matching so the tab stays lit.
  { to: ROUTES.lens, label: 'Lens', Icon: LensIcon, exact: false },
  { to: ROUTES.curate, label: 'Curate', Icon: CurateIcon, exact: true },
];

/**
 * Bottom tab bar shown on <900px viewports — three-tab mobile pattern. Hidden on desktop, where the SideNav takes over.
 */
export function BottomNav() {
  return (
    <nav className={styles.bar} aria-label="Primary navigation">
      {NAV_ITEMS.map(({ to, label, Icon, exact }) => (
        <NavLink
          key={to}
          to={to}
          end={exact !== false}
          className={({ isActive }) =>
            isActive ? `${styles.item} ${styles.itemActive}` : styles.item
          }
        >
          <span className={styles.itemIcon} aria-hidden="true">
            <Icon width={22} height={22} />
          </span>
          <span className={styles.itemLabel}>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
